import { z } from 'zod';

export const InputSchema = z.object({
    addressId: z.string(),
});

export const SuccessResponseSchema = z.object({
    Items: z.array(
        z.object({
            Line1: z.string().optional(),
            Line2: z.string().optional(),
            Line3: z.string().optional(),
            Line4: z.string().optional(),
            Line5: z.string().optional(),

            City: z.string().optional(),
            PostalCode: z.string().optional(),

            CountryName: z.string().optional(),
            CountryIso2: z.string().optional(),
            CountryIso3: z.string().optional(),

            Company: z.string().optional(),
            BuildingName: z.string().optional(),
            BuildingNumber: z.string().optional(),
            Street: z.string().optional(),

            Type: z.string().optional(),
            Label: z.string().optional(),
            //NOTE: api return more fields. Investigate if need extra
        })
    ),
});

export type SuccessResponseType = z.infer<typeof SuccessResponseSchema>;
export type AddressDetailsItemType = SuccessResponseType['Items'][number];

export type ResponseType = { responseStatus: 'success'; data: SuccessResponseType };
